import { CHAT_API, getToken } from "./chatConfig";

export interface ApiResult { success: boolean; message?: any; [k: string]: any }

/** فراخوانی یک عملیات API گفتگو (همیشه resolve می‌شود؛ خطا در success=false است) */
export async function call(action: string, body: Record<string, any> = {}): Promise<ApiResult> {
  try {
    const r = await fetch(`${CHAT_API}?action=${action}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
      body: JSON.stringify(body),
    });
    if (r.status === 401) window.dispatchEvent(new Event("chat:unauthorized"));
    return await r.json();
  } catch {
    return { success: false, message: "ارتباط با سرور برقرار نشد" };
  }
}

export interface UploadResult { success: boolean; url?: string; name?: string; size?: number; mime?: string; message?: string }

/** آپلود با نوار پیشرفت */
export function uploadFile(file: File | Blob, name: string, onProgress?: (pct: number) => void): Promise<UploadResult> {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${CHAT_API}?action=upload`);
    xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
    xhr.upload.onprogress = e => { if (e.lengthComputable) onProgress?.(Math.round((e.loaded / e.total) * 100)); };
    xhr.onload = () => { try { resolve(JSON.parse(xhr.responseText)); } catch { resolve({ success: false, message: "پاسخ نامعتبر از سرور" }); } };
    xhr.onerror = () => resolve({ success: false, message: "آپلود ناموفق بود" });
    const fd = new FormData(); fd.append("file", file, name);
    xhr.send(fd);
  });
}
